import React, { useEffect, useState, useRef } from "react";
import gameLogo from "../../assets/images/logo-header.svg";
import {
  setPhoneError,
  setPhoneNumber,
  setAge,
  setLabelCheck,
  setConfirmPin,
  setPin,
  setReferralCode,
  setErrorMessage,
  handleRegisterOtp,
  setOtpSuccess,
  setSignupSuccess,
  setAffiliateCode,
  setPrevPath,
} from "./cl_SignUpSlice";
import { useDispatch, useSelector } from "react-redux";
import OTPScreen from "./OTPScreen";
import { Link, useLocation } from "react-router-dom";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useNavigate } from "react-router-dom";
import { handleSignIn } from "../signIn/cl_SignInSlice";
import { setResetSuccess } from "../resetpage/cl_ResetSlice";
import { trackRegistrationOTPSent } from "../../service/gtag";
import { endpoints } from "../../api/ApiEndPoints";

function SignUp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [change, setChange] = useState(false);
  const phoneNumInput = useRef(null);
  const {
    phoneNumber,
    age,
    confirmPin,
    pin,
    loader,
    referralCode,
    otpSuccess,
    errorMessage,
    signupSuccess,
    labelCheck,
    prevPath,
    affiliateCode,
  } = useSelector((state) => state?.signUp);

  useEffect(() => {
    if (change) {
      phoneNumInput.current.focus();
    }
  }, [change]);

  const [hidePassword, setHidePassword] = useState(true);
  const [hideConfirmPwd, setHideConfirmPwd] = useState(true);
  const { resetSuccess, resetOtpScreen } = useSelector(
    (state) => state.resetPage
  );
  const [phoneErrMsg, setPhoneErrMsg] = useState("");
  const [labelErrMsg, setLabelErrMsg] = useState("");
  const [ageErrMsg, setAgeErrMsg] = useState("");
  const [pinErrMsg, setPinErrMsg] = useState("");
  const [confirmPinErrMsg, setConfirmPinErrMsg] = useState("");
  const [numberLength, setNumberLength] = useState(false);
  const inputRef = useRef(null);
  const secretKey = endpoints?.hashMap;

  const handleHidePaswword = () => {
    setHidePassword(!hidePassword);
  };

  const handleHideConfirmPwd = () => {
    setHideConfirmPwd(!hideConfirmPwd);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const afid = searchParams.get("afid");
  const refid = searchParams.get("refid");

  if (afid) {
    dispatch(setAffiliateCode(afid));
  }
  if (refid) {
    dispatch(setReferralCode(refid));
  }

  useEffect(() => {
    if (prevPath) {
      return;
    }
    dispatch(setPhoneNumber(""));
    dispatch(setAge(""));
    dispatch(setPin(""));
    dispatch(setConfirmPin(""));
    dispatch(setLabelCheck(true));
    dispatch(setOtpSuccess(false));
    dispatch(setSignupSuccess(false));
    dispatch(setResetSuccess(false));
    dispatch(setErrorMessage(""));
  }, []);

  function avoidCharacter(e) {
    const re = /[0-9]+/g;
    if (!re.test(e.key)) {
      e.persist();
      e.preventDefault();
    }
    if (e.key === "Enter") {
      !loader && handleSignUp();
    }
  }

  const handleAgeChange = (event) => {
    dispatch(setAge(event?.target?.value));
    setAgeErrMsg("");
  };

  const handlePinChange = (event) => {
    if (loader) return;
    const value = event?.target?.value;
    const numericValue = value.replace(/\D/g, "");
    dispatch(setPin(numericValue));
    setPinErrMsg("");
    dispatch(setErrorMessage(""));
  };

  const handleConfirmPinChange = (event) => {
    if (loader) return;
    const value = event?.target?.value;
    const numericValue = value.replace(/\D/g, "");
    dispatch(setConfirmPin(numericValue));
    setConfirmPinErrMsg("");
    dispatch(setErrorMessage(""));
  };

  const handleReferalCodeChange = (event) => {
    dispatch(setReferralCode(event?.target?.value));
  };

  useEffect(() => {
    if (labelCheck) {
      setLabelErrMsg("");
    } else {
      setLabelErrMsg("");
    }
  }, [labelCheck]);

  const handleSignUp = () => {
    if (loader) return;

    if (phoneNumber === "" || phoneNumber === null || phoneNumber.length < 9) {
      setPhoneErrMsg("Please enter a valid 9-digit Mobile Number");
    } else if (
      numberLength &&
      phoneNumber?.charAt(1) !== "7" &&
      phoneNumber?.charAt(1) !== "1"
    ) {
      setPhoneErrMsg("Please enter a valid 9-digit Mobile Number");
    } else if (
      !numberLength &&
      phoneNumber?.charAt(0) !== "7" &&
      phoneNumber?.charAt(0) !== "1"
    ) {
      setPhoneErrMsg("Please enter a valid 9-digit Mobile Number");
    } else if (age === "" || age === null) {
      setAgeErrMsg("Please select your age");
    } else if (pin === "" || pin === null || pin.length < 4) {
      setPinErrMsg("Please enter a Valid 4 Digit PIN");
    } else if (
      confirmPin === "" ||
      confirmPin === null ||
      confirmPin?.length < 4
    ) {
      setConfirmPinErrMsg("Please confirm your 4-digit PIN");
    } else if (pin !== confirmPin) {
      dispatch(
        setErrorMessage("Please enter same PIN value in both the fields")
      );
    } else if (!labelCheck) {
      setLabelErrMsg("Please accept the terms and conditions.");
    } else {
      trackRegistrationOTPSent(phoneNumber, secretKey);
      dispatch(handleRegisterOtp(phoneNumber));
    }

    if (age === "" || age === null) {
      setAgeErrMsg("Please select your age");
    }
    if (pin === "" || pin === null || pin.length < 4) {
      setPinErrMsg("Please enter a Valid 4 Digit PIN");
    }
    if (confirmPin === "" || confirmPin === null || confirmPin?.length < 4) {
      setConfirmPinErrMsg("Please confirm your 4-digit PIN");
    }
    if (!labelCheck) {
      setLabelErrMsg("Please accept the terms and conditions.");
    }
  };

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  const handleNumber = (e) => {
    dispatch(setPhoneError(false));
    dispatch(setErrorMessage(""));
    setPhoneErrMsg("");
    const re = /[0-9]+/g;
    if (
      re.test(e.nativeEvent.data) ||
      e.nativeEvent.inputType === "deleteContentBackward" ||
      e.nativeEvent.inputType === "deleteContentForward"
    ) {
      dispatch(setPhoneNumber(e.target.value));
    }
  };

  useEffect(() => {
    if (signupSuccess) {
      dispatch(handleSignIn(phoneNumber, pin, navigate, "signup"));
    }
  }, [signupSuccess]);

  // const handleDeposit = () => {
  //   dispatch(handleSignIn(phoneNumber, pin, navigate, "signup"));
  // };

  useEffect(() => {
    if (phoneNumber?.charAt(0) == "0") {
      setNumberLength(true);
    } else {
      setNumberLength(false);
    }
  }, [phoneNumber]);

  const handleNavBack = () => {
    if (otpSuccess && !signupSuccess) {
      dispatch(setOtpSuccess(false));
      dispatch(setSignupSuccess(false));
      dispatch(setErrorMessage(""));
    } else {
      dispatch(setPrevPath(false));
      navigate(-1);
    }
  };

  return (
    <React.Fragment>
      <div className="SB-Lite SB-nonLoggedIn SB-homePage">
        <div
          className="SB-modal  SB-register-modal SB-modal-fullscreen open"
          id="SB-register-modal"
        >
          <div className="SB-modal-dialog">
            <div className="SB-modal-content">
              <div className="SB-modal-body">
                <div className="SB-loginRegister SB-register">
                  <div className="SB-loginRegister-innercontainer">
                    <div className="SB-pageHeader">
                      {signupSuccess && !otpSuccess ? (
                        ""
                      ) : (
                        <div
                          className="SB-pageBackButton"
                          id="SB-pageBackBtn"
                          data-dismiss="modal"
                          onClick={handleNavBack}
                        >
                          <div className="SB-iconSVG" title="back">
                            <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${"icon-back"}`} />
                            </svg>
                          </div>
                        </div>
                      )}
                      <div className="SB-pageHeader-title">
                        <div>SignUP</div>
                      </div>
                      <div
                        className="SB-pageHeader-logo"
                        onClick={() => {
                          navigate("/");
                          dispatch(setPrevPath(false));
                          if (signupSuccess && !otpSuccess);
                          {
                            dispatch(
                              handleSignIn(phoneNumber, pin, navigate, "logo")
                            );
                          }
                        }}
                      >
                        <img src={gameLogo} alt="logo" />
                      </div>
                    </div>
                    <div className="SB-loginRegister-banner">
                      <div className="SB-loginRegister-discription">
                        <img
                          src={require("../../assets/images/popup/signup_login-reload_topleft.webp")}
                          alt="Reload Bonus"
                        />
                      </div>
                      <div className="SB-contentImage">
                        <img
                          src={require("../../assets/images/popup/signup_login-reload_topright.webp")}
                          alt="Reload Bonus"
                        />
                      </div>
                    </div>
                    <div className="SB-loginRegister-content">
                      <div className="SB-loginRegister-promoBanner">
                        <img
                          src={require("../../assets/images/banners/signup_login_deposit-reload.gif")}
                          alt="login-banner"
                        />
                      </div>
                      {!(otpSuccess || signupSuccess) && (
                        <div id="singUpStep1">
                          <div className="SB-loginRegister-title">Sign Up</div>
                          <div className="SB-loginRegister-form">
                            <div className="SB-form-group">
                              <div className="SB-form-label">Mobile Number</div>
                              <div className="SB-form-control-group SB-mobileNumberField">
                                <div className="SB-form-addon SB-addon-left">
                                  <div className="SB-regionCode">+254</div>
                                </div>
                                <div
                                  className={`SB-form-control ${
                                    phoneErrMsg ? "SB-error" : ""
                                  }`}
                                >
                                  <input
                                    type={"tel"}
                                    ref={phoneNumInput}
                                    placeholder="Enter your mobile number"
                                    onKeyPress={(e) => avoidCharacter(e)}
                                    onChange={(e) => handleNumber(e)}
                                    value={phoneNumber}
                                    maxLength={numberLength ? 10 : 9}
                                  />
                                </div>
                                <div className="SB-form-addon SB-addon-right">
                                  <div className="SB-iconSVG SB-iconVerified d-none">
                                    <svg xmlns="http://www.w3.org/2000/svg">
                                      <use xlinkHref="images/sprite-other-icons.svg#icon-check"></use>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div className="SB-form-errorMsg">
                                <span id=""> {phoneErrMsg}</span>
                              </div>
                            </div>
                            <div className="SB-form-group">
                              <div className="SB-form-label">Select Age</div>
                              <div
                                className={`SB-form-control-group ${
                                  ageErrMsg ? "SB-error" : ""
                                }`}
                              >
                                <div className="SB-select">
                                  <select
                                    value={age}
                                    onChange={handleAgeChange}
                                  >
                                    <option value={""}>Select</option>
                                    <option value={"18-30"}>18-30</option>
                                    <option value={"31-50"}>31-50</option>
                                    <option value={"51-70"}>51-70</option>
                                    <option value={"71-100"}>
                                      71 and above
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div className="SB-form-errorMsg">
                                <span>{ageErrMsg}</span>
                              </div>
                            </div>
                            <div className="SB-form-group">
                              <div className="SB-form-label">4 Digit PIN</div>
                              <div className="SB-form-control-group SB-form-control-password">
                                <div
                                  className={`SB-form-control ${
                                    pinErrMsg ? "SB-error" : ""
                                  }`}
                                >
                                  <input
                                    type={hidePassword ? "password" : "tel"}
                                    placeholder="Enter your PIN"
                                    maxLength={4}
                                    onKeyPress={(e) => avoidCharacter(e)}
                                    value={pin}
                                    onChange={handlePinChange}
                                    required=""
                                  />
                                </div>
                                <div className="SB-form-addon SB-addon-right">
                                  <div
                                    className={`SB-iconSVG ${
                                      !hidePassword ? "d-none" : ""
                                    }`}
                                    title="password active"
                                    id="getShowPwdId"
                                    onClick={handleHidePaswword}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="#946969"
                                    >
                                      <use
                                        xlinkHref={`${icons}#${"icon-password-active"}`}
                                      />
                                    </svg>
                                  </div>
                                  <div
                                    className={`SB-iconSVG ${
                                      !hidePassword ? "" : "d-none"
                                    }`}
                                    title="Password hide"
                                    id="getHidePwdId"
                                    onClick={handleHidePaswword}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="#946969"
                                    >
                                      <use
                                        xlinkHref={`${icons}#${"icon-password"}`}
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div className="SB-form-errorMsg">
                                <span>{pinErrMsg}</span>
                              </div>
                            </div>
                            <div className="SB-form-group">
                              <div className="SB-form-label">
                                Confirm 4 Digit PIN
                              </div>
                              <div className="SB-form-control-group SB-form-control-password">
                                <div
                                  className={`SB-form-control ${
                                    confirmPinErrMsg ? "SB-error" : ""
                                  }`}
                                >
                                  <input
                                    type={hideConfirmPwd ? "password" : "tel"}
                                    placeholder="Enter your PIN"
                                    onKeyPress={(e) => avoidCharacter(e)}
                                    onChange={handleConfirmPinChange}
                                    maxLength={4}
                                    value={confirmPin}
                                    required=""
                                  />
                                </div>
                                <div className="SB-form-addon SB-addon-right">
                                  <div
                                    className={`SB-iconSVG ${
                                      !hideConfirmPwd ? "d-none" : ""
                                    }`}
                                    title="password active"
                                    id="getShowPwdId"
                                    onClick={handleHideConfirmPwd}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="#946969"
                                    >
                                      <use
                                        xlinkHref={`${icons}#${"icon-password-active"}`}
                                      />
                                    </svg>
                                  </div>
                                  <div
                                    className={`SB-iconSVG ${
                                      !hideConfirmPwd ? "" : "d-none"
                                    }`}
                                    title="Password hide"
                                    id="getHidePwdId"
                                    onClick={handleHideConfirmPwd}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      fill="#946969"
                                    >
                                      <use
                                        xlinkHref={`${icons}#${"icon-password"}`}
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div className="SB-form-errorMsg">
                                <span>{confirmPinErrMsg}</span>
                              </div>
                            </div>
                            <div className="SB-form-group">
                              <div className="SB-form-label">
                                {affiliateCode
                                  ? ""
                                  : " Referral Code (Optional)"}
                              </div>
                              {affiliateCode ? (
                                ""
                              ) : (
                                <div className="SB-form-control-group SB-form-control-couponCode">
                                  <div className="SB-form-control">
                                    <input
                                      type="text"
                                      placeholder="Enter your referral code"
                                      // value={affiliateCode ? affiliateCode : referralCode}
                                      value={referralCode}
                                      onChange={handleReferalCodeChange}
                                      // disabled={affiliateCode ? true : false}
                                    />
                                  </div>
                                </div>
                              )}
                              <div className="SB-form-errorMsg">
                                <span></span>
                              </div>
                            </div>
                            <div className="SB-form-group">
                              <div className="SB-checkbox">
                                <input
                                  id="termsandconditions"
                                  name=""
                                  value="check1"
                                  checked={labelCheck ? "checked" : ""}
                                  type="checkbox"
                                  onChange={() => {
                                    dispatch(setLabelCheck(!labelCheck));
                                  }}
                                />
                                <label htmlFor="termsandconditions"></label>
                                <span
                                  className="SB-checkboxLabel"
                                  onClick={() => dispatch(setPrevPath(true))}
                                >
                                  <b>I am over 18. </b> I accept the{" "}
                                  <Link to={"/terms-conditions"}>
                                    Terms &amp; Conditions
                                  </Link>{" "}
                                  and{" "}
                                  <Link to={"/privacyPolicy"}>
                                    Privacy Policy
                                  </Link>
                                  .
                                </span>
                              </div>
                              <div className="SB-form-errorMsg">
                                <span>{labelErrMsg}</span>
                              </div>
                              {errorMessage && (
                                <div className="SB-form-errorMsg text-center">
                                  <span>{errorMessage}</span>
                                </div>
                              )}
                            </div>
                            <button
                              className="btn SB-btnlogin SB-btnSecondary active SB-btnLarge"
                              id="btnProceed"
                              onClick={handleSignUp}
                            >
                              <div className="SB-btnTxt">
                                {loader ? "" : "Proceed"}
                              </div>
                              <div
                                className={`SB-loader-container ${
                                  loader ? "" : "d-none"
                                }`}
                              >
                                <div className="SB-loader"></div>
                              </div>
                            </button>
                          </div>
                          <div className="SB-loginRegister-navigation">
                            Have an Account?{" "}
                            <a>
                              <span
                                className="SB-txtHightlight"
                                onClick={() => {
                                  navigate("/signin");
                                  dispatch(setPrevPath(false));
                                }}
                              >
                                Login
                              </span>
                            </a>
                          </div>
                        </div>
                      )}
                      {((otpSuccess && !signupSuccess) || resetSuccess) && (
                        <OTPScreen setChange={setChange} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SignUp;
